(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["damper-cro-design"] && !Shopify.designMode) return;
  try {
    (function(){
  function revealHash(){
    const id=decodeURIComponent(location.hash.slice(1));
    if(!id)return;
    const target=document.getElementById(id);
    if(target instanceof HTMLDetailsElement)target.open=true;
  }
  function initNavigation(){
    document.querySelectorAll('.dc-mobile-menu a').forEach(a=>a.addEventListener('click',()=>{a.closest('details').open=false;}));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.dc-mobile-menu[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
    document.addEventListener('click',e=>{
      const link=e.target.closest('a[href^="#"]');if(!link)return;
      const target=document.getElementById(link.getAttribute('href').slice(1));
      if(target instanceof HTMLDetailsElement)target.open=true;
    });
    window.addEventListener('hashchange',revealHash);revealHash();
  }

  let disposeScrollHeader;
  function initScrollHeader(){
    if(disposeScrollHeader)disposeScrollHeader();
    const header=document.querySelector('.dc-header');
    if(!header)return;
    let slot=header.parentElement;
    if(!slot.classList.contains('dc-header-slot')){
      slot=document.createElement('div');slot.className='dc-header-slot';
      header.before(slot);slot.append(header);
    }
    const menu=header.querySelector('.dc-mobile-menu');
    let lastY=Math.max(0,window.scrollY),travel=0,direction=0,frame=0,hidden=false,top=0,height=0;
    function measure(){
      height=header.offsetHeight;slot.style.height=height+'px';
      header.style.setProperty('--dc-header-height',height+'px');
      top=slot.getBoundingClientRect().top+window.scrollY;
    }
    function update(){
      frame=0;
      const y=Math.max(0,Math.min(window.scrollY,document.documentElement.scrollHeight-window.innerHeight));
      const delta=y-lastY,nextDirection=Math.sign(delta);
      if(nextDirection&&nextDirection!==direction){travel=0;direction=nextDirection;}
      travel+=Math.abs(delta);
      const fixed=y>top;
      if(!fixed||y<top+height)hidden=false;
      else if(travel>=6){hidden=direction>0;travel=0;}
      if(menu?.open||header.contains(document.activeElement)&&document.activeElement.matches(':focus-visible'))hidden=false;
      header.classList.toggle('dc-header-fixed',fixed);
      header.classList.toggle('dc-header-hidden',fixed&&hidden);
      lastY=y;
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    function resize(){measure();schedule();}
    function focus(){hidden=false;header.classList.remove('dc-header-hidden');}
    const observer=new ResizeObserver(resize);observer.observe(header);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',resize);
    header.addEventListener('focusin',focus);
    menu?.addEventListener('toggle',schedule);
    measure();update();
    disposeScrollHeader=()=>{
      observer.disconnect();cancelAnimationFrame(frame);
      window.removeEventListener('scroll',schedule);window.removeEventListener('resize',resize);
      header.removeEventListener('focusin',focus);menu?.removeEventListener('toggle',schedule);
    };
  }

  function initBundles(){
    if(!document.body.classList.contains('dc-page-product'))return;
    const root=document.querySelector('[data-product-root]');
    const strings=document.querySelector('.dc-bundle-strings');
    if(!root||!strings)return;
    let running=false,queued=false,wasAdded=false;
    function enhance(){
      if(running)return;running=true;
      const offers=root.querySelector('[id^="offers-list-container"]');
      if(offers){
        let details=offers.closest('.dc-bundle-details');
        if(!details){
          details=document.createElement('details');details.className='dc-bundle-details';
          const summary=document.createElement('summary');summary.textContent=strings.dataset.setTitle;
          details.append(summary);offers.before(details);details.append(offers);
          const hint=document.createElement('p');hint.className='dc-bundle-hint';hint.textContent=strings.dataset.hint;details.append(hint);
          const selected=document.createElement('p');selected.className='dc-bundle-selected';selected.hidden=true;selected.setAttribute('aria-live','polite');details.after(selected);
        }
        offers.querySelectorAll('.pb-1856').forEach(p=>{
          const next=p.textContent.replace(/dní/g,'denných dávok').replace(/za deň/g,'za dennú dávku');
          if(p.textContent!==next)p.textContent=next;
        });
        offers.querySelectorAll('.pb-43cd a').forEach(a=>{if(a.textContent!==strings.dataset.gift)a.textContent=strings.dataset.gift;});
        offers.querySelectorAll('.pb-b7d0 p').forEach(p=>{if(p.textContent.trim()==='Free')p.textContent=strings.dataset.giftLabel;});
        const checked=offers.querySelector('input[name="offer"]:checked');
        const card=checked?.closest('.pb-6b5d');
        const title=card?.querySelector('.pb-56aa')?.textContent.trim();
        const price=card?.querySelector('.pb-1aad')?.textContent.trim();
        const isSet=!!title&&!title.startsWith('60 ');
        const selected=details.nextElementSibling;
        const summary=details.querySelector('summary');
        const summaryText=isSet?strings.dataset.selected+': '+title:strings.dataset.setTitle;
        if(summary.textContent!==summaryText)summary.textContent=summaryText;
        if(selected?.classList.contains('dc-bundle-selected')){
          const next=isSet?title+' · '+price:'';
          if(selected.textContent!==next)selected.textContent=next;
          selected.hidden=!isSet;
        }
        offers.querySelectorAll('input[name="offer"]').forEach(input=>{
          if(!input.getAttribute('aria-label'))input.setAttribute('aria-label',input.id.trim());
        });
      }
      const added=root.querySelector('[x-ref="added"]');
      const isAdded=!!added&&getComputedStyle(added).display!=='none';
      if(isAdded&&!wasAdded)refreshCartCount();
      wasAdded=isAdded;
      running=false;
    }
    function schedule(){if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;enhance();});}
    const observer=new MutationObserver(schedule);observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','style']});
    root.addEventListener('click',()=>setTimeout(schedule,0));
    root.addEventListener('change',schedule);enhance();
  }
  function refreshCartCount(){
    const url=(window.Shopify?.routes?.root||'/')+'cart.js';
    fetch(url,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(cart=>{
      if(cart&&Number.isInteger(cart.item_count))document.querySelectorAll('[data-dc-cart-count]').forEach(el=>{el.textContent=cart.item_count;});
    }).catch(()=>{});
  }
  function initReviewCarousels(){
    document.querySelectorAll('[data-dc-review-carousel]:not([data-ready])').forEach(root=>{
      const track=root.querySelector('.dc-review-slides');
      const slides=Array.from(track.children);
      if(slides.length<2)return;
      for(let i=slides.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[slides[i],slides[j]]=[slides[j],slides[i]];}
      slides.forEach((slide,i)=>{track.append(slide);slide.setAttribute('aria-label',slide.getAttribute('aria-label').replace(/\d+/,String(i+1)));});
      const position=root.querySelector('[data-review-position]');
      const announcement=root.querySelector('[data-review-announcement]');
      const toggle=root.querySelector('[data-review-toggle]');
      const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
      let current=0,playing=!reducedMotion.matches,hovered=false,timer=null,touchStart=null;
      function show(index,manual){
        current=(index+slides.length)%slides.length;
        slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===current);slide.setAttribute('aria-hidden',String(i!==current));slide.inert=i!==current;});
        position.textContent=(current+1)+' / '+slides.length;
        if(manual)announcement.textContent=slides[current].getAttribute('aria-label');
      }
      function schedule(){
        clearTimeout(timer);
        toggle.textContent=playing?root.dataset.pauseLabel:root.dataset.playLabel;
        if(!root.isConnected||!playing||hovered||root.contains(document.activeElement)||document.hidden)return;
        timer=setTimeout(()=>{show(current+1,false);schedule();},8000);
      }
      function move(step){show(current+step,true);schedule();}
      root.querySelector('[data-review-prev]').addEventListener('click',()=>move(-1));
      root.querySelector('[data-review-next]').addEventListener('click',()=>move(1));
      toggle.addEventListener('click',()=>{playing=!playing;schedule();});
      root.addEventListener('mouseenter',()=>{hovered=true;schedule();});
      root.addEventListener('mouseleave',()=>{hovered=false;schedule();});
      root.addEventListener('focusin',schedule);
      root.addEventListener('focusout',()=>setTimeout(schedule,0));
      root.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
      track.addEventListener('touchstart',e=>{touchStart=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
      track.addEventListener('touchend',e=>{if(!touchStart)return;const dx=e.changedTouches[0].clientX-touchStart.x,dy=e.changedTouches[0].clientY-touchStart.y;touchStart=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))move(dx<0?1:-1);},{passive:true});
      document.addEventListener('visibilitychange',schedule);
      reducedMotion.addEventListener('change',()=>{if(reducedMotion.matches)playing=false;schedule();});
      root.dataset.ready='true';
      root.querySelector('[data-review-controls]').hidden=false;
      show(0,false);schedule();
    });
  }
  function init(){initScrollHeader();initNavigation();initBundles();initReviewCarousels();document.body.addEventListener('shapes:cart:afteradditem',refreshCartCount);window.addEventListener('shapes:cart:update',refreshCartCount);}
  document.addEventListener('shopify:section:load',()=>{initReviewCarousels();initScrollHeader();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["damper-cro-reading"] && !Shopify.designMode) return;
  try {
    function initializeDamperReading() {
  const content = document.querySelector('[data-dc-reading]');
  const nav = document.querySelector('[data-dc-toc]');
  if (!content || !nav) return;
  nav.replaceChildren();
  const headings = [...content.querySelectorAll('h2')];
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `dc-reading-${index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    nav.append(link);
  });
  const aside = nav.closest('.dc-reading-aside');
  if (headings.length < 2 && aside) aside.hidden = true;
  const toc = nav.closest('details');
  if (toc && window.matchMedia('(max-width: 989px)').matches) toc.open = false;
  content.querySelectorAll('table').forEach(table => {
    if (!table.parentElement.classList.contains('dc-readable-table')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'dc-readable-table';
      table.before(wrapper);wrapper.append(table);
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeDamperReading);
else initializeDamperReading();
document.addEventListener('shopify:section:load', initializeDamperReading);
  } catch(e) { console.error(e); }
})();

})();
